import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Grid, Cell, Icon, RadialProgress, ProgressBar } from '@teamsnap/teamsnap-ui';
import WidgetBase from 'shared/components/Widget';
import WidgetCounts from 'shared/components/Widget/WidgetCounts';
import styles from './Widget.module.scss';

class CompleteLayout extends PureComponent {
  renderChart = () => {
    const { chartType, chartProgress } = this.props;

    return chartType === 'radial' ? (
      <RadialProgress size="xlarge" progress={ chartProgress } mods={ styles.RadialMods } />
    ) : (
      <ProgressBar isVertical isPrecise progress={ chartProgress } />
    );
  };

  renderTopSection = () => {
    const { counters, iconName, chartType, infoTop } = this.props;

    return (
      <Grid>
        <Cell mods="u-size2of3 u-textCenter">
          { chartType ? this.renderChart() : <Icon style={ { fontSize: '150px', color: '#eee' } } name={ iconName } /> }
        </Cell>

        <Cell mods="u-size1of3">
          <WidgetCounts items={ counters } mods="u-size1of1" />
        </Cell>

        { infoTop && (
          <Cell mods="u-size1of1">
            <span className={ `${styles.WidgetFooterInfo} u-textCenter u-spaceTopSm` }>{ infoTop }</span>
          </Cell>
        ) }
      </Grid>
    );
  };

  render() {
    const { infoComponent, headerText, isLoading, buttonText, buttonLocation, buttonColor, children } = this.props;

    return (
      <WidgetBase
        headerText={ headerText }
        infoComponent={ infoComponent }
        isLoading={ isLoading }
        buttonText={ buttonText }
        buttonLocation={ buttonLocation }
        buttonColor={ buttonColor }
      >
        { this.renderTopSection() }
        { children }
      </WidgetBase>
    );
  }
}

CompleteLayout.propTypes = {
  iconName: PropTypes.string,
  chartType: PropTypes.string,
  chartProgress: PropTypes.number,
  counters: PropTypes.arrayOf(PropTypes.shape({})),
  infoComponent: PropTypes.node,
  infoTop: PropTypes.node,
  headerText: PropTypes.string,
  isLoading: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonLocation: PropTypes.string,
  buttonColor: PropTypes.string,
  children: PropTypes.node,
};

CompleteLayout.defaultProps = {
  iconName: null,
  chartType: null,
  chartProgress: null,
  counters: [],
  infoComponent: null,
  infoTop: null,
  headerText: null,
  isLoading: false,
  buttonText: null,
  buttonLocation: null,
  buttonColor: null,
  children: null,
};

export default CompleteLayout;
